import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ce93cfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-sm-12" }
const _hoisted_8 = { class: "nav" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = {
  key: 0,
  class: "row"
}
const _hoisted_12 = { class: "col-sm-12 d-flex align-items-center justify-content-end mb-16" }
const _hoisted_13 = ["data-bs-target"]
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-sm-12" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Photo Match Status: ")
const _hoisted_17 = {
  key: 0,
  class: "table"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "Metadata"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_19 = { scope: "row" }
const _hoisted_20 = { class: "row mb-3" }
const _hoisted_21 = { class: "col-sm-6 box" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Document Type", -1))
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Document Type", -1))
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "col-sm-6" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, "Document Type is approved?", -1))
const _hoisted_28 = { class: "form-check mb-3" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_31 = { class: "form-check mb-3" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Reason", -1))
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "row mb-3" }
const _hoisted_38 = { class: "col-sm-6" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Official Doc Front", -1))
const _hoisted_40 = { class: "dropzone" }
const _hoisted_41 = ["src", "alt"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-file-image" })
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Official Doc Front Preview", -1))
const _hoisted_44 = { class: "col-sm-6" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, "Official Doc Front is approved?", -1))
const _hoisted_46 = { class: "form-check mb-3" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_49 = { class: "form-check mb-3" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_52 = { class: "mb-3" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Reason", -1))
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "row mb-3" }
const _hoisted_56 = { class: "col-sm-6" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Official Doc Back", -1))
const _hoisted_58 = { class: "dropzone" }
const _hoisted_59 = ["src", "alt"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-file-image" })
], -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Official Doc Back Preview", -1))
const _hoisted_62 = { class: "col-sm-6" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, "Official Doc Back is approved?", -1))
const _hoisted_64 = { class: "form-check mb-3" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_67 = { class: "form-check mb-3" }
const _hoisted_68 = ["disabled"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_70 = { class: "mb-3" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Reason", -1))
const _hoisted_72 = ["disabled"]
const _hoisted_73 = { class: "row mb-3" }
const _hoisted_74 = { class: "col-sm-6" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Selfie Image", -1))
const _hoisted_76 = { class: "dropzone" }
const _hoisted_77 = ["src", "alt"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-file-image" })
], -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Selfie Image Preview", -1))
const _hoisted_80 = { class: "col-sm-6" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, "Selfie Image is approved?", -1))
const _hoisted_82 = { class: "form-check mb-3" }
const _hoisted_83 = ["disabled"]
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_85 = { class: "form-check mb-3" }
const _hoisted_86 = ["disabled"]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_88 = { class: "mb-3" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Reason", -1))
const _hoisted_90 = ["disabled"]
const _hoisted_91 = {
  key: 1,
  class: "d-flex justify-content-end"
}
const _hoisted_92 = ["disabled"]
const _hoisted_93 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OCRModal = _resolveComponent("OCRModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("ul", _hoisted_8, [
                    _createElementVNode("li", {
                      class: "nav-item",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tab = 1))
                    }, [
                      _createElementVNode("h2", {
                        class: _normalizeClass(_ctx.tab == 1 ? 'nav-link active' : 'nav-link')
                      }, " KYC ", 2)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.tab == 1)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    method: "POST",
                    onSubmit: _cache[17] || (_cache[17] = (e) => e.preventDefault())
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      (_ctx.meta)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("button", {
                                class: "btn btn-success btn-sm",
                                "data-bs-toggle": "modal",
                                "data-bs-target": `#${_ctx.$modals.VIEW_OCR_MODAL}`
                              }, " View OCR ", 8, _hoisted_13)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("h4", null, [
                            _hoisted_16,
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", 
                            _ctx.kyc.photo_verified ? 'badge-info' : 'badge-danger'
                          ])
                            }, _toDisplayString(_ctx.kyc.photo_verified ? "Matched" : "Not matched"), 3)
                          ]),
                          (_ctx.kyc.doc_metadata)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_17, [
                                _hoisted_18,
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.metadata), (key) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: key }, [
                                      _createElementVNode("td", _hoisted_19, _toDisplayString(key), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.metadata[key]), 1)
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("div", _hoisted_23, [
                            _hoisted_24,
                            _createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              value: _ctx.docTypes[_ctx.kyc.doc_type],
                              readonly: ""
                            }, null, 8, _hoisted_25)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createElementVNode("div", _hoisted_28, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.review.doc_type) = $event)),
                              value: true,
                              disabled: _ctx.reviewDisable
                            }, null, 8, _hoisted_29), [
                              [_vModelRadio, _ctx.review.doc_type]
                            ]),
                            _hoisted_30
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.review.doc_type) = $event)),
                              value: false,
                              disabled: _ctx.reviewDisable
                            }, null, 8, _hoisted_32), [
                              [_vModelRadio, _ctx.review.doc_type]
                            ]),
                            _hoisted_33
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _hoisted_35,
                            _withDirectives(_createElementVNode("textarea", {
                              class: "form-control",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.review.desc_doc_type) = $event)),
                              disabled: _ctx.reviewDisable,
                              id: "exampleFormControlTextarea1",
                              rows: "8"
                            }, null, 8, _hoisted_36), [
                              [_vModelText, _ctx.review.desc_doc_type]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _createElementVNode("div", _hoisted_40, [
                            (_ctx.frontDoc)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.frontDoc.src,
                                  alt: _ctx.frontDoc.alt_text,
                                  class: "img-fluid-kyc"
                                }, null, 8, _hoisted_41))
                              : _createCommentVNode("", true),
                            (!_ctx.frontDoc)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_42,
                                  _hoisted_43
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _createElementVNode("div", _hoisted_46, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.review.official_doc) = $event)),
                              value: true,
                              disabled: _ctx.reviewDisable
                            }, null, 8, _hoisted_47), [
                              [_vModelRadio, _ctx.review.official_doc]
                            ]),
                            _hoisted_48
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.review.official_doc) = $event)),
                              value: false,
                              disabled: _ctx.reviewDisable
                            }, null, 8, _hoisted_50), [
                              [_vModelRadio, _ctx.review.official_doc]
                            ]),
                            _hoisted_51
                          ]),
                          _createElementVNode("div", _hoisted_52, [
                            _hoisted_53,
                            _withDirectives(_createElementVNode("textarea", {
                              class: "form-control",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.review.desc_official_doc) = $event)),
                              disabled: _ctx.reviewDisable,
                              id: "exampleFormControlTextarea1",
                              rows: "8"
                            }, null, 8, _hoisted_54), [
                              [_vModelText, _ctx.review.desc_official_doc]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _hoisted_57,
                          _createElementVNode("div", _hoisted_58, [
                            (_ctx.backDoc)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.backDoc.src,
                                  alt: _ctx.backDoc.alt_text,
                                  class: "img-fluid-kyc"
                                }, null, 8, _hoisted_59))
                              : _createCommentVNode("", true),
                            (!_ctx.backDoc)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_60,
                                  _hoisted_61
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _hoisted_63,
                          _createElementVNode("div", _hoisted_64, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.review.official_doc_back) = $event)),
                              value: true,
                              disabled: _ctx.reviewDisable
                            }, null, 8, _hoisted_65), [
                              [_vModelRadio, _ctx.review.official_doc_back]
                            ]),
                            _hoisted_66
                          ]),
                          _createElementVNode("div", _hoisted_67, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.review.official_doc_back) = $event)),
                              value: false,
                              disabled: _ctx.reviewDisable
                            }, null, 8, _hoisted_68), [
                              [_vModelRadio, _ctx.review.official_doc_back]
                            ]),
                            _hoisted_69
                          ]),
                          _createElementVNode("div", _hoisted_70, [
                            _hoisted_71,
                            _withDirectives(_createElementVNode("textarea", {
                              class: "form-control",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.review.desc_official_doc_back) = $event)),
                              disabled: _ctx.reviewDisable,
                              id: "exampleFormControlTextarea1",
                              rows: "8"
                            }, null, 8, _hoisted_72), [
                              [_vModelText, _ctx.review.desc_official_doc_back]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, [
                          _hoisted_75,
                          _createElementVNode("div", _hoisted_76, [
                            (_ctx.selfie)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.selfie.src,
                                  alt: _ctx.selfie.alt_text,
                                  class: "img-fluid-kyc"
                                }, null, 8, _hoisted_77))
                              : _createCommentVNode("", true),
                            (!_ctx.selfie)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_78,
                                  _hoisted_79
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_80, [
                          _hoisted_81,
                          _createElementVNode("div", _hoisted_82, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.review.live_photo) = $event)),
                              value: true,
                              disabled: _ctx.reviewDisable
                            }, null, 8, _hoisted_83), [
                              [_vModelRadio, _ctx.review.live_photo]
                            ]),
                            _hoisted_84
                          ]),
                          _createElementVNode("div", _hoisted_85, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.review.live_photo) = $event)),
                              value: false,
                              disabled: _ctx.reviewDisable
                            }, null, 8, _hoisted_86), [
                              [_vModelRadio, _ctx.review.live_photo]
                            ]),
                            _hoisted_87
                          ]),
                          _createElementVNode("div", _hoisted_88, [
                            _hoisted_89,
                            _withDirectives(_createElementVNode("textarea", {
                              class: "form-control",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.review.desc_live_photo) = $event)),
                              disabled: _ctx.reviewDisable,
                              id: "exampleFormControlTextarea1",
                              rows: "8"
                            }, null, 8, _hoisted_90), [
                              [_vModelText, _ctx.review.desc_live_photo]
                            ])
                          ])
                        ])
                      ]),
                      (_ctx.roles.admin)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                            _createElementVNode("button", {
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('cancel'))),
                              type: "button",
                              class: "btn btn-secondary w-md me-2"
                            }, " Cancel "),
                            _createElementVNode("button", {
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.updateOrCreateReview(true, true))),
                              type: "button",
                              class: "btn btn-info w-md me-2"
                            }, " Update "),
                            (_ctx.allApproved)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.submit(true))),
                                  type: "submit",
                                  class: "btn btn-primary w-md",
                                  disabled: _ctx.reviewDisable
                                }, " Approve ", 8, _hoisted_92))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.submit(false))),
                                  type: "submit",
                                  class: "btn btn-danger w-md me-2",
                                  disabled: _ctx.reviewDisable
                                }, " Decline ", 8, _hoisted_93))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 32))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_OCRModal, {
      meta: _ctx.meta,
      "is-admin": ""
    }, null, 8, ["meta"])
  ], 64))
}